export default "__VITE_ASSET__B_eSYi2e__"